export const millisecondsIn89Days = 89 * 24 * 60 * 60 * 1000;
export const getTimeFromTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
};
